import React from 'react';
import { Button, Space } from 'antd';
import { MinusOutlined, PlusOutlined } from '@ant-design/icons';

const MAX_QUANTITY = 99;

type Props = {
  quantity: number;
  onChange: (quantity: number) => void;
};

const DishQuantityControl: React.FC<Props> = ({ quantity, onChange }) => (
  <Space size={8} align='center' onClick={e => e.stopPropagation()}>
    <Button
      size='small'
      shape='circle'
      type='link'
      variant='solid'
      icon={<MinusOutlined />}
      onClick={() => onChange(quantity - 1)}
      style={{ borderColor: '#e8ecef' }}
    />
    <span
      style={{
        minWidth: 24,
        textAlign: 'center',
        fontWeight: 600,
        fontSize: 15,
        color: '#1a3c34',
      }}
    >
      {quantity}
    </span>
    <Button
      size='small'
      shape='circle'
      type='link'
      variant='solid'
      icon={<PlusOutlined />}
      disabled={quantity >= MAX_QUANTITY}
      onClick={() => onChange(quantity + 1)}
      style={{ borderColor: '#e8ecef' }}
    />
  </Space>
);

export default DishQuantityControl;
